module.exports = __webpack_public_path__ + "img/ccf-3.55b18d51.webp";